import React from "react";
import {useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import DonutChart from "./DonutChart";
import BarPieDonutChartRightControls from "./controls/BarPieDonutChartRightControls";
import BarPieDonutChartTopControls from "./controls/BarPieDonutChartTopControls";
import {
    chartDataActiveBarPieDonutChartAtomFamily,
    visualizationTypeToDisplayAtomFamily
} from "./state/BarPieDonutChartState";
import * as _ from "lodash";
import {
    activeFilterSetIdAtom,
    facetFiltersAtomFamily
} from "../../../../../dataProvider/vissights/search/filters/filters";
import {sliderValuesAtomFamily} from "../../../../GlobalNavigations/LeftNavigation/LeftNavigationState";
import BarChart from "./BarChart";
import PieChart from "./PieChart";

function BarPieDonutChartContainer(props) {
    const componentId = props.id;
    const topControlConfig = props.topControls[0];
    const [chartDataActive, setChartData] = useRecoilState(chartDataActiveBarPieDonutChartAtomFamily(componentId));
    const visType = useRecoilValue(visualizationTypeToDisplayAtomFamily(componentId));
    // stuff we pass to top controls
    const deleteContainer = props.deleteContainer;
    const activeFilterSetId = useRecoilValue(activeFilterSetIdAtom);
    const [facetFilters, toggleFacetFilters] = useRecoilState(facetFiltersAtomFamily(activeFilterSetId));
    const setSliderValues = useSetRecoilState(sliderValuesAtomFamily(activeFilterSetId));
    const resetSliderValues = useResetRecoilState(sliderValuesAtomFamily(activeFilterSetId));

    const toggleFacetFilter = (facet, value) => {
        // console.log(facet, value)
        value = value.toString()
        const clone = _.cloneDeep(facetFilters);
        // check if the facet is already created as another filter in that facet is created or sth like that.
        const isAlreadyCreated = clone.find((d) => {
            return d.facet === facet;
        });
        if (isAlreadyCreated !== undefined) {
            // check if we have to reset the slider.
            if (facet === 'Years') {
                resetSliderValues();
            }
            clone.map((d) => {
                if (d.facet === facet) {
                    // check if value is already set...
                    const valueAlready = d.values.find((e, i) => {
                        return e === value;
                    })
                    // if value is already set we remove it
                    if (valueAlready !== undefined) {
                        d.values = d.values.filter((d) => d !== value);
                    }
                    // if its new we add it.
                    else {
                        // d.value = d.value.push(value);
                        d.values.push(value);
                    }
                }
                return d;
            })
        } else {
            // check if we have to change the slider.
            if (facet === 'Years') {
                setSliderValues([Number(value), Number(value)])
            }
            clone.push({facet: facet, values: [value]});
        }
        //remove no longer used facets
        const filteredClone = clone.filter((d) => d.values.length > 0);
        toggleFacetFilters(filteredClone);
    }

    return (
        <div>
            <BarPieDonutChartTopControls topControlConfig={topControlConfig}
                                         deleteContainer={deleteContainer}
                                         id={props.id}/>
            <div style={{display: "flex"}}>
                <div style={{width: props.containerDimensions[0]}}>
                    {(() => {
                        switch (visType) {
                            case "Bar":
                                return (<BarChart data={chartDataActive}
                                                  id={props.id}
                                                  width={props.containerDimensions[0]}
                                                  height={props.containerDimensions[1]}
                                                  toggleFacetFilter={toggleFacetFilter}
                                                  toggleContextMenu = {props.toggleContextMenu}
                                />)
                            case "Pie":
                                return (<PieChart data={chartDataActive}
                                                  id={props.id}
                                                  width={props.containerDimensions[0]}
                                                  height={props.containerDimensions[1]}
                                                  toggleFacetFilter={toggleFacetFilter}
                                                  toggleContextMenu = {props.toggleContextMenu}
                                />)
                            case "Donut":
                                return (<DonutChart data={chartDataActive}
                                                    id={props.id}
                                                    width={props.containerDimensions[0]}
                                                    height={props.containerDimensions[1]}
                                                    toggleFacetFilter={toggleFacetFilter}
                                                    toggleContextMenu = {props.toggleContextMenu}
                                />)
                        }
                    })()}
                </div>
                <div style={{width: 200, overflowY: "hidden"}}>
                    <BarPieDonutChartRightControls id={props.id}
                                                   height={props.containerDimensions[1]}
                                                   width={props.containerDimensions[0]}
                                                   topControlConfig={topControlConfig}
                                                   setLocalChartData={setChartData}
                                                   toggleRightControls={props.toggleRightControls}
                                                   displayRightNav={props.displayRightNav}/>
                </div>
            </div>
        </div>
    );
}

export default BarPieDonutChartContainer;